import React from 'react';

import { ToolTip } from '../../../../common/tool-tip/ToolTip';
import { AvailabilityTable } from './AvailabilityTable';

import './ClientAvailability.css';

export const ClientAvailability = ({
  context,
  toolTipsEnabled,
  showToaster,
  setSpinnerText,
  availability,
  setAvailability,
  fieldsDisabled,
}) => {
  return (
    <div className="availability-container">
      <h3 className="availability-container-header">
        Which day(s) of the week is the client available for a clinic visit?
        {toolTipsEnabled && (
          <ToolTip
            tooltipExternalReference={'clientAvailability123'}
            context={context}
            setSpinnerText={setSpinnerText}
            showToaster={showToaster}
            fieldName={'Which day(s) of the week is the client available for a clinic visit?'}
          />
        )}
      </h3>

      <AvailabilityTable
        availability={availability}
        setAvailability={setAvailability}
        fieldsDisabled={fieldsDisabled}
      />
    </div>
  );
};
